import * as Sentry from '@sentry/nextjs';
import { PaymentFulfillmentChannelsEnum } from 'types/generated/client';
import api from 'services/client/api';
import { getAuthHeaders } from 'services/client/token';
import { detectFraudFromBrowser } from 'utils/shared/fraud/detectFraud';

interface Params {
  lessonId: string;
  providerCardId?: string;
  paymentFulfillmentChannel?: PaymentFulfillmentChannelsEnum;
  referralName?: string;
}

export type { Params };

export const createLessonPayment = async ({
  lessonId,
  providerCardId,
  paymentFulfillmentChannel,
  referralName,
}: Params) => {
  // Check for fraud before making the payment request
  const fraudDetection = detectFraudFromBrowser();
  if (fraudDetection.isFraud) {
    Sentry.captureException(new Error('Fraud attempt detected during lesson payment'), {
      extra: {
        reason: fraudDetection.reason,
        timezone: fraudDetection.timezone,
        locale: fraudDetection.locale,
        lessonId,
        paymentFulfillmentChannel,
      },
    });
    throw new Error('Unable to process payment. Please try again later.');
  }

  const headers = await getAuthHeaders();
  return api.post(`v1/lessons/${lessonId}/participant/pay`, {
    ...headers,
    payload: {
      providerCardId,
      paymentFulfillmentChannel,
      referralName,
      timezone: fraudDetection.timezone,
      locale: fraudDetection.locale,
    },
  });
};
